import originalFetch from 'isomorphic-fetch'
import qs from 'qs';
import _ from 'underscore';
import { goLogin } from './util';

export const getAuth = () => {
  // return '9de65cdc44dc39a4dbf79049cf19d3605949cd2a70f1346b8ec55ae1dbadbe574f70763607a89a8bdc3f4c5a35f2513807872c0e8c18c01f1c0ee01825b2af031c47d323f5f09cea2bb684dd02dc3cd90bba828c93d19a84c1c4a4f556df2fa539179a3317550c0aca203a4d946ae7073f377477edb65f249e36a65734a8e2251396a865a3968571f371134994e36755';
  return localStorage.getItem('authHeader');
}

export function fetch(url, query = {}, config = {}) {
  function genQueryUrl(url, query) {
    const queryString = [];
    Object.keys(query).forEach(key => {
      if (query[key] !== undefined && query[key] !== null) {
        queryString.push(`${key}=${query[key]}`);
      }
    });

    return queryString.length ? `${url}?${queryString.join('&')}` : url;
  }

  // with cookie&content-type
  _.defaults(config, {
    credentials: 'include',
    headers: {},
    method: 'GET'
  });
  // 带authHeader
  const authHeader = getAuth();
  if (authHeader) {
    config.headers.AUTH = authHeader;
  }
  if (config.method === 'GET') {
    url = genQueryUrl(url, query)
  } else if (config.method === 'POST') {
    if (!(config.body instanceof FormData)) {
      if (!config.headers['Content-Type'] || config.headers['Content-Type'] === 'application/json') {
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(query)
      } else {
        config.body = qs.stringify(query)
      }
    }
    // if (query) {
    //   if() {
    //   }else{
    //   }
    // }
  } else {
    return false;
  }
  return originalFetch(url, config).then(
    res => {
      if (res.ok) {
        return res.json().then(json => {
          if (json.code === 60105) {
            //兑换码已经使用了哟～
            return Promise.resolve(json);
          }
          if ([401, 403].includes(json.code) ) {
            //账户cookie 验证权限失败的时候 跳转登录
            goLogin();
            return Promise.reject({code: 403});
          }
          if (json.code === 400) {
            //兑换码不存在
            return Promise.resolve(json);
          }
          if (json.code === 200) {
            return Promise.resolve(json);
          } else {
            return Promise.reject(json);
          }
        });
      } else if (res.status === 403) {
        goLogin();
        return Promise.reject({code: 403});
      }
      return res.json().then(Promise.reject.bind(Promise));
    }
  ).catch((err) => {
    return Promise.reject(err);
  });
}
